import React from 'react';

import { FooterContentEntity } from '../../domain/entities/FooterContentEntity';
import { FooterLink } from '../../view-model/types/FooterTypes';
import styles from '../styles/Footer.module.scss';

import FooterLinkSectionCmp from './FooterLinkSectionCmp';

// Mirrors FooterLinksMapper.footer_link_mapper: a footer link's display title
// is the CMS label and its href is the CMS link.
function footerLinkMapper(title: string, link: string): FooterLink {
  return { title, link };
}

interface FooterFeaturesCmpProps {
  footer_data?: FooterContentEntity;
  query_params: string;
}

function FooterFeaturesCmp({
  footer_data,
  query_params,
}: Readonly<FooterFeaturesCmpProps>): React.ReactElement {
  return (
    <div className={styles['footer-features']}>
      <div className={styles['footer-primary']}>
        {footer_data ? (
          footer_data.service_links_list.map(serviceLinks => (
            <FooterLinkSectionCmp
              key={serviceLinks.title}
              className={styles['services-links']}
              content={{
                title: serviceLinks.title,
                links: serviceLinks.link_label_pairs.map(pair =>
                  footerLinkMapper(pair.label, pair.link),
                ),
              }}
              query_params={query_params}
            />
          ))
        ) : (
          <div />
        )}
      </div>
      <div className={styles['footer-secondary']}>
        {footer_data ? (
          <FooterLinkSectionCmp
            className={styles['cities-truck-links']}
            content={{
              title: footer_data.city_links_list.title,
              links: footer_data.city_links_list.link_label_pairs.map(pair =>
                footerLinkMapper(pair.label, pair.link),
              ),
            }}
            query_params={query_params}
          />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

export default FooterFeaturesCmp;
